export const photoLocationDialogMixin = {
  data() {
    return {
      photoDetailsVisible: true,
      photographerDialog: false,
      locationDialog: false,
      map: null,
      marker: null
    }
  },
  methods: {
    isLocationDialogVisible(value) {
      if (value || this.locationDialog) {
        setTimeout(() => {
          this.createMap()
        }, 100)
      } else {
        this.map.remove()
        this.map = null
      }
    },
    createMap() {
      const center = [this.photo.longitude, this.photo.latitude]
      const Mapboxgl = this.$mapboxgl
      this.marker = new Mapboxgl.Marker()
      this.marker.setLngLat(center)

      this.map = new Mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        zoom: 10,
        center
      })
      this.marker.addTo(this.map)
      const nav = new Mapboxgl.NavigationControl()
      this.map.addControl(nav, 'top-right')
    },
    showLocation() {
      this.locationDialog = true
    },
    closeLocationDialog() {
      this.map.remove()
      this.map = null
      this.locationDialog = false
    }
  }
}
